import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import {
  UnderCarriageForm,
  UnderCarriageListResponse,
} from "../types";
import {
  selectUnderCarriageForm,
  selectUnderCarriagePage,
  selectUnderCarriagePerPage,
} from "./selector";
import { underCarriageActions } from "./slice";

let isFetchingList = false;

export function* handleGetUnderCarriageList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectUnderCarriagePage);
    const perPage: number = yield select(selectUnderCarriagePerPage);

    const response: UnderCarriageListResponse = yield call(
      request,
      `${API_URL}/sub-chassis/list?page=${page}&perPage=${perPage}`,
      { method: "GET" }
    );

    const data = response?.data || [];
    const meta = getPaginationMeta(page, perPage, data, response?.meta);
    const payload = { data, meta };

    if (page === 1) {
      yield put(underCarriageActions.getUnderCarriageListSuccess(payload));
    } else {
      yield put(underCarriageActions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectUnderCarriagePage);

    if (page === 1) {
      yield put(underCarriageActions.getUnderCarriageListError(message));
    } else {
      yield put(underCarriageActions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAddUnderCarriage() {
  const form: UnderCarriageForm = yield select(selectUnderCarriageForm);

  try {
    yield call(request, `${API_URL}/sub-chassis`, {
      method: "POST",
      body: JSON.stringify({
        subChassisId: form.code.trim(),
        subChassisName: form.description.trim(),
        subChassisHeight: Number(form.height),
      }),
    });

    yield put(underCarriageActions.addUnderCarriageSuccess());
    yield put(underCarriageActions.getUnderCarriageList());
  } catch (error) {
    yield put(
      underCarriageActions.addUnderCarriageError((error as Error).message)
    );
  }
}

export function* underCarriageSaga() {
  yield takeLeading(
    [
      underCarriageActions.getUnderCarriageList.type,
      underCarriageActions.getNextPageItems.type,
    ],
    handleGetUnderCarriageList
  );
  yield takeLatest(
    underCarriageActions.addUnderCarriage.type,
    handleAddUnderCarriage
  );
}

export default underCarriageSaga;
